import firebase from "firebase/compat/app";
import "firebase/compat/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCim3NwXfHVf7B1fEflHfIRei9ZFDS1aYk",
  authDomain: "yt-pro-clone.firebaseapp.com",
  projectId: "yt-pro-clone",
  storageBucket: "yt-pro-clone.appspot.com",
  messagingSenderId: "556616874486",
  appId: "1:556616874486:web:938e06aa6ea367eac8afd7",
};

firebase.initializeApp(firebaseConfig);

export default firebase.auth();
